import { createSlice } from "@reduxjs/toolkit";

import GetCustomer from "../Actions/GetCustomer-Action";

const initialState = {
  customerData: [],
  loading: false,
  isLoaded: false,
  status: "",
  PaginationToken: "",
  loadMore: false,
  searching: false,
};
const Customer = createSlice({
  name: "Customer list",
  initialState,
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setIsLoaded(state, action) {
      state.isLoaded = action.payload;
    },
    setCustomerList(state, action) {
      state.customerData = action.payload;
    },
    searchData(state, action) {
      state.customerData = action.payload.res;
    },
    setSearching(state, action) {
      state.searching = action.payload;
    },
    setPaginationToken(state, action) {
      state.PaginationToken = action.payload;
    },
    setLoadMore(state, action) {
      state.loadMore = action.payload;
    },
  },
  extraReducers: {
    [GetCustomer.pending]: (state, action) => {
      if (state.PaginationToken === "") {
        state.loading = true;
      } else {
        state.loadMore = true;
      }
    },
    [GetCustomer.fulfilled]: (state, action) => {
      let currentArr = state.customerData;
      let newArr = [];
      newArr = action.payload.res;

      state.customerData = currentArr.concat(newArr);
      state.PaginationToken = action?.payload?.PaginationToken
        ? action.payload.PaginationToken
        : "";
      state.loading = false;
      state.loadMore = false;
    },
    [GetCustomer.rejected]: (state, action) => {
      state.loading = false;
      state.loadMore = false;
      state.status = action?.error?.message;
    },
  },
});

export const CustomerAction = Customer.actions;

export default Customer.reducer;
